(function(module) {

    "use strict";

    function constructor(filterBuilder) {

        // -------------------------------------------------------------------------------------------
        // The following functions create the filters from the content using the filter builders
        // -------------------------------------------------------------------------------------------

        var createLocationFilter = asCheckBoxGroup("Location", aggregator(createArrayExtractor(function(result) {
            return result.locations.map(function (location) {
                return location.name;
            });
        })));


        // -------------------------------------------------------------------------------------------
        // General function for extracting properties and aggregating
        // -------------------------------------------------------------------------------------------

        /**
         * The extractor returns a function, it maps a hotel to a tuple of the value
         * of apply the propertyExtractor to a hotel and the hotel ID
         *
         * @param  {Function} propertyExtractor a function that takes a hotel and returns the filter value for that hotel
         * @return {Function} the extratcor function
         */
        function createArrayExtractor(propertyExtractor) {
            return function(results) {
                var properties = results.map(function (result) {
                    var propertyNames = propertyExtractor(result);
                    var propertyIds = result.locations.map(function (location) {
                        return location.id;
                    });
                    var propertiesWithIds = [];
                    for (var i = 0; i < propertyNames.length && i < propertyIds.length; i++) {
                        if (propertyNames[i] != null && propertyIds[i] != null) {
                            propertiesWithIds.push([propertyNames[i], propertyIds[i]]);
                        }
                    }
                    return propertiesWithIds;
                });
                return properties.reduce(function(collector, properties) {
                    return collector.concat(properties);
                }, []);
            };
        }

        /**
         * The aggregator function aggregates together hotel IDs which have the
         * same filter value
         *
         * @param  {Function} extractor the extractor function, see createExtractor
         * @return {Function} the function to apply to an array of hotels
         */
        function aggregator(extractor) {
            return function(results) {
                var aggregated = extractor(results).reduce(function(aggregator, tuple) {
                    aggregator[tuple[0]] = aggregator[tuple[0]] != null
                        ? aggregator[tuple[0]].concat([tuple[1]])
                        : [tuple[1]];
                    return aggregator;
                }, Object.create(null));

                return Object.keys(aggregated).map(function(key) {
                    return [key, aggregated[key]];
                });
            };
        }

        // -------------------------------------------------------------------------------------------
        // Functions that take an extractor, they use the filter builder API to create the filters
        // -------------------------------------------------------------------------------------------

        /**
         * A function that takes filter group name and an extractor, it will return a function
         * that takes the filter builder and an array of hotels, it will add a checkbox group
         * to the filter builder
         *
         * @param  {String} name the name of the filter group
         * @param  {Function} extractor the extractor function
         * @return {Function} a function to create the group
         */
        function asCheckBoxGroup(name, extractor) {
            return function(builder, results) {

                // 1. create the checkbox group
                var checkBoxGroup = builder.addCheckBoxFilters(name);

                // 2. call the extractor, for text groups this gives us
                //    a tuple ["property", ["id1", "id2", ..."idN"]]
                //    and add the filter groups
                extractor(results).forEach(function(tuple) {
                    checkBoxGroup.addFilter(tuple[0], tuple[1]);
                });
            };
        }

        // -------------------------------------------------------------------------------------------
        // Result Filters
        // -------------------------------------------------------------------------------------------
        return function(results) {
            var builder = filterBuilder();
            createLocationFilter(builder, results);
            return builder.build();
        };
    }

    module.factory("activityFilters", ["filterBuilder", constructor]);

})(angular.module("vhols"));
